import BarChart from './BarChart';
import ComboChart from './ComboChart';
import DoughnutChart from './DoughnutChart';
import LineChart from './LineChart';
import PieChart from './PieChart';
export default {
	BarChart,
	ComboChart,
	DoughnutChart,
	LineChart,
	PieChart
};
